import { Dialog, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ProductService } from "../../../services/api";
import FormInput from "../../molecules/FormInput";
import FormTemplate from "../../templates/FormTemplate";
import useRefresh from "../../../hooks/useRefresh";
import currencies from "../../../assets/currencies.json";

interface CreateProductDialogProps {
  open: boolean;
  onSubmit?: () => void;
  onClose?: () => void;
}

export default function CreateProductDialog(props: CreateProductDialogProps) {
  const { t } = useTranslation("Product");
  const refresh = useRefresh();
  const [currency, setCurrency] = useState("");
  const [group, setGroup] = useState("");
  const [itemCode, setItemCode] = useState("");
  const [name, setName] = useState("");
  const [price, setPrice] = useState(0);
  const [extRef, setExtRef] = useState("");

  useEffect(() => {
    if (!props.open) return;
    setCurrency("");
    setGroup("");
    setItemCode("");
    setName("");
    setPrice(0);
    setExtRef("");
  }, [props.open]);

  const handleSubmit = async () => {
    const res = await ProductService.createProduct({
      createProductBody: {
        currency,
        group,
        itemCode,
        name,
        price,
        extRef,
      },
    });
    if (res?.data?.success) {
      refresh();
      props.onClose?.();
    }
  };
  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <FormTemplate
        title={t("CreateProduct")}
        onSubmit={handleSubmit}
        onCancel={props.onClose}
      >
        <Stack spacing={2} sx={{ minWidth: { xs: 350, sm: 400, md: 500 } }}>
          <FormInput
            field="itemCode"
            label={t("ItemCode")}
            value={itemCode}
            type="string"
            onChange={(v) => setItemCode(v as string)}
            required
          />
          <FormInput
            field="name"
            label={t("Name")}
            type="string"
            value={name}
            onChange={(v) => setName(v as string)}
            required
          />
          <FormInput
            field="group"
            label={t("Group")}
            type="string"
            value={group}
            onChange={(v) => setGroup(v as string)}
            required
          />
          <FormInput
            field="price"
            label={t("Price")}
            type="number"
            value={price}
            onChange={(v) => setPrice(v as number)}
            required
          />
          <FormInput
            field="currency"
            label={t("Currency")}
            type="list"
            list={currencies}
            value={currency}
            onChange={(v) => setCurrency(v as string)}
            required
          />
          <FormInput
            field="extRef"
            label={t("ExtRef")}
            type="string"
            value={extRef}
            onChange={(v) => setExtRef(v as string)}
            required
          />
        </Stack>
      </FormTemplate>
    </Dialog>
  );
}
